import { Injectable } from '@angular/core'

import { Observable, Subject } from 'rxjs'

import { TriggeredAlertStatuses } from '@ti/contracts'

export interface DrivingScoreSourceChange {
  alertIds: string[]
  status: TriggeredAlertStatuses
}

/**
 * Local mutations of driving score inputs made by this client. The initiating client must not
 * depend on a realtime hint to refresh scores it already showed, so every loaded driving score
 * view treats a change as an invalidation of its retained state. The server derives live score
 * identity from committed sources, so a refresh after a review-only change stays cheap.
 */
@Injectable({ providedIn: 'root' })
export class DrivingScoreSourceChanges {
  private readonly changesSubject = new Subject<DrivingScoreSourceChange>()

  public readonly changes$: Observable<DrivingScoreSourceChange> =
    this.changesSubject.asObservable()

  public notify(change: DrivingScoreSourceChange): void {
    if (change.alertIds.length) {
      this.changesSubject.next(change)
    }
  }
}
